import React from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';
import { Accordion } from 'components';
import { theme, toRem } from 'design';
import { centsToDollarsDisplay } from 'utils/currency';

export interface ISummaryAccordionData {
  ccTips?: number;
  cashTips?: number;
}

export interface ISummaryAccordionProps {
  className?: string;
  data: ISummaryAccordionData;
  defaultOpenState?: boolean;
  isLoading?: boolean;
  title: string;
}

const Content = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  &:first-child {
    margin-top: ${toRem(8)};
  }

  &:not(:last-child) {
    margin-bottom: ${toRem(8)};
  }

  p {
    font-size: ${toRem(14)};
    font-weight: 400;
    color: ${theme.color.neutral[500]};
  }
`;

const SummaryAccordionLayout = styled(Accordion)`
  width: 100%;
`;

const Title = styled.p`
  font-size: ${toRem(14)};
  font-weight: 600;
`;

const SummaryAccordion: React.FC<ISummaryAccordionProps> = ({ className = '', data, defaultOpenState = false, isLoading, title }) => (
  <SummaryAccordionLayout className={className} defaultOpenState={defaultOpenState} trigger={isLoading ? <Skeleton width={100} /> : <Title>{title}</Title>}>
    <Content>
      <Row>
        <p>Credit Card Tips</p>
        {isLoading ? <Skeleton width={40} /> : <p>{centsToDollarsDisplay(data.ccTips || 0)}</p>}
      </Row>
      <Row>
        <p>Cash Card Tips</p>
        {isLoading ? <Skeleton width={40} /> : <p>{centsToDollarsDisplay(data.cashTips || 0)}</p>}
      </Row>
      <Row>
        <p>Total Tips</p>
        {isLoading ? <Skeleton width={40} /> : <p>{centsToDollarsDisplay((data.ccTips || 0) + (data.cashTips || 0))}</p>}
      </Row>
    </Content>
  </SummaryAccordionLayout>
);

export default SummaryAccordion;
